import { HighLevelCategoryComponent } from './high-level-category.component';
import { highLevelCategoryResolver } from './high-level-category.resolver';
import { Routes, UrlMatchResult, UrlSegment } from '@angular/router';

export function childPageMatcher(url:UrlSegment[]): UrlMatchResult | null{
  if(url.length > 0 && url[url.length - 1].path.startsWith('page-')){
    const consumed = url;
    const posParams: { [key:string]:UrlSegment } = {};
    posParams['page'] = url[ url.length - 1 ];
    if(url.length === 2){
      posParams['country'] = url[0];
    }
    else if(url.length === 3){
      posParams['country']  = url[0];
      posParams['state']    = url[1];
    }
    return { consumed, posParams}
  }
  return null;
}

export const HighLevelCategoryRoute: Routes = [
  {
    matcher:childPageMatcher,
    component: HighLevelCategoryComponent,
    resolve: { listingSeo: highLevelCategoryResolver },
  },
  {
    path: ':country/:state',
    component: HighLevelCategoryComponent,
    resolve: { listingSeo: highLevelCategoryResolver },
  },
  {
    path: '',
    component: HighLevelCategoryComponent,
    resolve: { listingSeo: highLevelCategoryResolver },
  },
  {
    path: ':country',
    component: HighLevelCategoryComponent,
    resolve: { listingSeo: highLevelCategoryResolver },
  },
  
];
